(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avena-cart-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avena-cart-editor')) {
  class AvenaCartEditor extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.selects=[...this.querySelectorAll('select')];
      this.button=this.querySelector('button');
      this.message=this.querySelector('[role="status"]');
      this.selects.forEach((select,index)=>select.addEventListener('change',()=>this.sync(index)));
      this.button.addEventListener('click',()=>this.save());
      this.sync(-1);
    }
    sync(changed) {
      this.selects.forEach((select,index)=>{
        const prefix=this.selects.slice(0,index).map(s=>s.value);
        for(const option of select.options) option.disabled=!this.variants.some(v=>v.available && v.options[index]===option.value && prefix.every((value,i)=>v.options[i]===value));
        if(index>changed && changed>=0 && select.selectedOptions[0]?.disabled) {
          const next=[...select.options].find(o=>!o.disabled);
          if(next)select.value=next.value;
        }
      });
      const choices=this.selects.map(select=>select.value);
      this.target=this.variants.find(v=>v.available && choices.every((value,index)=>v.options[index]===value));
      this.button.disabled=!this.target || String(this.target.id)===this.dataset.current;
      this.message.textContent=this.target?'':this.dataset.unavailable;
    }
    async save() {
      const drawer=this.closest('cart-drawer');
      if(!this.target || drawer.hasAttribute('data-avena-editing'))return;
      const root=window.Shopify.routes.root;
      const api=async(path,body)=>{
        const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}:{cache:'no-store'});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||'Cart update failed');
        return result;
      };
      const sectionIds=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sectionIds}}));
      const bundle={sections:[...new Set(sectionIds)].slice(0,5),sections_url:location.pathname};
      const publish=cart=>{
        if(cart.sections && Object.values(cart.sections).every(Boolean))document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      };
      const token=crypto.randomUUID();
      const label=this.button.textContent;
      drawer.setAttribute('data-avena-editing','');drawer.setAttribute('aria-busy','true');
      const locked=[...drawer.querySelectorAll('button,input,select')].filter(e=>!e.disabled);
      locked.forEach(e=>e.disabled=true);
      this.button.textContent=this.dataset.busy;this.message.textContent='';
      let original,removed=false;
      const matches=item=>item.variant_id===original.variant_id && JSON.stringify(item.properties||{})===JSON.stringify(original.properties||{}) && item.selling_plan_allocation?.selling_plan.id===original.selling_plan_allocation?.selling_plan.id;
      try {
        const before=await api('cart.js');
        original=before.items.find(item=>item.key===this.dataset.key);
        if(!original)throw new Error('Cart item changed');
        const replacement={id:this.target.id,quantity:original.quantity,properties:{...original.properties,_avena_edit:token}};
        if(original.selling_plan_allocation)replacement.selling_plan=original.selling_plan_allocation.selling_plan.id;
        await api('cart/add.js',{items:[replacement]});
        const interim=await api('cart.js');
        const old=interim.items.find(matches);
        if(!old)throw new Error('Cart item changed');
        const cart=await api('cart/change.js',{id:old.key,quantity:0,...bundle});
        removed=true;
        const edited=cart.items.find(item=>item.properties?._avena_edit===token);
        if(!edited || edited.quantity!==original.quantity || (original.properties?._avena_gift && edited.final_line_price!==0))throw new Error('Variant cannot retain gift offer');
        publish(cart);
      } catch(error) {
        try {
          if(removed && original) {
            const restore={id:original.variant_id,quantity:original.quantity,properties:original.properties};
            if(original.selling_plan_allocation)restore.selling_plan=original.selling_plan_allocation.selling_plan.id;
            await api('cart/add.js',{items:[restore]});
          }
          const current=await api('cart.js');
          const added=current.items.find(item=>item.properties?._avena_edit===token);
          if(added)publish(await api('cart/change.js',{id:added.key,quantity:0,...bundle}));
          this.message.textContent=this.dataset.error;
        } catch(restoreError) { location.href=root+'cart'; }
      } finally {
        drawer.removeAttribute('data-avena-editing');drawer.removeAttribute('aria-busy');
        locked.forEach(e=>e.disabled=false);this.button.textContent=label;
      }
    }
  }
  customElements.define('avena-cart-editor',AvenaCartEditor);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avena-gift"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('avena-gift-config');
  if (!config) return;
  const code = config.dataset.code;
  const root = window.Shopify.routes.root;
  const dialog = document.getElementById('avena-gift-dialog');
  const launcher = document.getElementById('avena-gift-open');
  let busy = false;
  const api = async (path, body) => {
    const response = await fetch(root + path, body ? { method:'POST', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify(body) } : {cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
    return data;
  };
  const sections = () => {
    const ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:ids}}));
    return [...new Set(ids)].slice(0,5);
  };
  const publish = (cart, open=false, baseEvent='variant:add') => {
    if (cart.sections && Object.values(cart.sections).every(Boolean)) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent,cart}}));
    } else document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (open) document.querySelector('cart-drawer')?.show?.();
  };
  const claimed = item => item.properties?._avena_gift === code;
  const clean = async cart => {
    const invalid = cart.items.filter(item => claimed(item) && (item.final_line_price !== 0 || item.quantity !== 1));
    if (!invalid.length) return cart;
    const updated = await api('cart/update.js',{updates:Object.fromEntries(invalid.map(item=>[item.key,0])),sections:sections(),sections_url:location.pathname});
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return updated; }
    publish(updated,false,'gift:clean');
    return updated;
  };
  document.addEventListener('cart:change', async event => {
    if (busy || !event.detail?.cart) return;
    busy = true;
    try { const cart=await clean(event.detail.cart); if(launcher)launcher.hidden=cart.items.some(claimed); } catch (error) { console.error('Gift cart check failed',error); } finally { busy=false; }
  });
  const initial = api('cart.js').then(async cart => { if (busy) return cart; busy=true; try { return await clean(cart); } finally { busy=false; } });
  initial.catch(()=>{});
  if (!dialog || !launcher) return;
  const claimButton = document.getElementById('avena-gift-claim');
  const errorLabel = document.getElementById('avena-gift-error');
  const originalLabel = claimButton.textContent;
  const key = 'avena-gift-seen-v1';
  const form = () => [...document.querySelectorAll('form[is="product-form"]')].find(f => f.querySelector('[name="product-id"]')?.value === dialog.dataset.product && !f.closest('quick-buy-drawer'));
  const open = async () => {
    if (busy) return;
    try {
      const cart = await api('cart.js');
      if (cart.items.some(claimed)) { launcher.hidden=true; return; }
      if (document.querySelector('cart-drawer[open],quick-buy-drawer[open],dialog[open]')) return;
      if (!dialog.querySelector('input[name="avena-gift-choice"]')) return;
      dialog.showModal();
      try { sessionStorage.setItem(key,'1'); } catch(error) {}
    } catch(error) {}
  };
  const close = () => { if (!busy) dialog.close(); };
  launcher.addEventListener('click',open);
  dialog.querySelector('.avena-gift-close').addEventListener('click',close);
  dialog.querySelector('.avena-gift-dismiss').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  dialog.addEventListener('change',event=>{
    if(event.target.matches('select')) event.target.closest('label').querySelector('input').checked=true;
    claimButton.disabled=!dialog.querySelector('input[name="avena-gift-choice"]:checked');
  });
  initial.then(cart=>{
    if(cart.items.some(claimed))return;
    launcher.hidden=false;
    let seen=false;
    try{seen=sessionStorage.getItem(key)==='1';}catch(error){}
    if(!seen)setTimeout(open,3000);
  }).catch(()=>{});
  claimButton.addEventListener('click',async()=>{
    if(busy)return;
    const choice=dialog.querySelector('input[name="avena-gift-choice"]:checked');
    const productForm=form();
    if(!choice)return;
    if(!productForm || !productForm.checkValidity()) { errorLabel.textContent=dialog.dataset.select; return; }
    const data=new FormData(productForm);
    const variantId=data.get('id');
    if(!variantId || data.get('selling_plan') || productForm.querySelector('button[type="submit"]')?.disabled) { errorLabel.textContent=dialog.dataset.select; return; }
    busy=true;claimButton.disabled=true;claimButton.textContent=dialog.dataset.busy;errorLabel.textContent='';
    const token=crypto.randomUUID();
    let priorCodes=[];
    let attempted=false;
    try {
      const before=await api('cart.js');
      if(before.items.some(claimed))throw new Error(dialog.dataset.existing);
      priorCodes=(before.discount_codes||[]).map(entry=>entry.code).filter(value=>value.toUpperCase()!==code);
      const properties={_avena_purchase:token};
      for(const [name,value] of data) { const match=name.match(/^properties\[(.+)\]$/); if(match && typeof value==='string')properties[match[1]]=value; }
      const giftVariant=choice.closest('label').querySelector('select').value;
      attempted=true;
      await api('cart/add.js',{items:[{id:Number(variantId),quantity:Math.max(1,Number(data.get('quantity'))||1),properties},{id:Number(giftVariant),quantity:1,properties:{_avena_gift:code,_avena_claim:token}}]});
      const cart=await api('cart/update.js',{discount:[...priorCodes,code].join(','),sections:sections(),sections_url:location.pathname});
      const gift=cart.items.find(item=>item.properties?._avena_claim===token);
      if(!gift || gift.final_line_price!==0)throw new Error(dialog.dataset.error);
      dialog.close();launcher.hidden=true;publish(cart,true);
    } catch(error) {
      if(attempted) {
        try {
          const current=await api('cart.js');
          const added=current.items.filter(item=>item.properties?._avena_claim===token || item.properties?._avena_purchase===token);
          const restored=await api('cart/update.js',{updates:Object.fromEntries(added.map(item=>[item.key,0])),discount:priorCodes.join(','),sections:sections(),sections_url:location.pathname});
          publish(restored);
        } catch(rollbackError) { location.href=root+'cart'; return; }
      }
      errorLabel.textContent=error.message===dialog.dataset.existing ? error.message : dialog.dataset.error;
    } finally {busy=false;claimButton.disabled=false;claimButton.textContent=originalLabel;}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avena-pack-gift"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('avena-pack-gift-config');
  if (!config) return;
  const code = config.dataset.code;
  const root = window.Shopify.routes.root;
  const dialog = document.getElementById('avena-pack-gift-dialog');
  const launcher = document.getElementById('avena-pack-gift-open');
  const claimButton = document.getElementById('avena-pack-gift-claim');
  const errorLabel = document.getElementById('avena-pack-gift-error');
  const originalLabel = claimButton?.textContent;
  const keys = ['Gave ved pakning','Gavevariant','Gave-SKU','Gave-variant-ID','_avena_gift_handle'];
  const markerStart = '[AVENA GAVE TIL PAKNING]';
  const markerEnd = '[/AVENA GAVE TIL PAKNING]';
  let busy = false;
  let changeOnly = false;
  const api = async (path, body) => {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Cart error');
    return result;
  };
  const sections = () => {
    const ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:ids}}));
    return [...new Set(ids)].slice(0,5);
  };
  const publish = (cart, open=false) => {
    if (cart.sections && Object.values(cart.sections).every(Boolean)) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'gift:packing',cart}}));
    } else document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (open) document.querySelector('cart-drawer')?.show?.();
  };
  const legacy = item => item.properties?._avena_gift === code;
  const eligible = cart => cart.items.some(item => !legacy(item) && !item.gift_card && item.quantity > 0);
  const picked = cart => Boolean(cart.attributes?.['Gave ved pakning']);
  const stripGiftNote = note => {
    const start = (note || '').indexOf(markerStart);
    const end = (note || '').indexOf(markerEnd, start);
    return start >= 0 && end >= start ? (note.slice(0,start) + note.slice(end + markerEnd.length)).trim() : (note || '');
  };
  const giftValues = gift => ({
    'Gave ved pakning':gift?.title || '',
    'Gavevariant':gift?.variant || '',
    'Gave-SKU':gift?.sku || '',
    'Gave-variant-ID':gift?.id ? String(gift.id) : '',
    '_avena_gift_handle':gift?.handle || ''
  });
  const giftFromCart = cart => ({title:cart.attributes?.['Gave ved pakning'],variant:cart.attributes?.['Gavevariant'],sku:cart.attributes?.['Gave-SKU'],id:cart.attributes?.['Gave-variant-ID'],handle:cart.attributes?._avena_gift_handle});
  const update = async (cart, gift) => {
    const attributes = giftValues(gift);
    const cleanNote = stripGiftNote(cart.note);
    const giftNote = gift ? `${markerStart}\n1 gratis gave: ${gift.title}\nVariant: ${gift.variant || 'Default Title'}\nSKU: ${gift.sku || '—'}\nVariant-ID: ${gift.id}\nLægges manuelt i pakken. Ikke en betalt ordrelinje.\n${markerEnd}` : '';
    const body = {attributes,note:[cleanNote,giftNote].filter(Boolean).join('\n\n'),updates:Object.fromEntries(cart.items.filter(legacy).map(item=>[item.key,0])),sections:sections(),sections_url:location.pathname};
    const discounts = cart.discount_codes || [];
    if (discounts.some(entry=>entry.code.toUpperCase() === code)) body.discount = discounts.filter(entry=>entry.code.toUpperCase() !== code).map(entry=>entry.code).join(',');
    const result = await api('cart/update.js',body);
    if (gift && result.attributes?.['Gave-variant-ID'] !== String(gift.id)) throw new Error('Gift not saved');
    return result;
  };
  const reconcile = async cart => {
    const oldGift = cart.items.find(legacy);
    const oldCode = (cart.discount_codes || []).some(entry=>entry.code.toUpperCase() === code);
    if (!eligible(cart) && (picked(cart) || oldGift || oldCode)) {
      const updated = await update(cart,null); publish(updated);return updated;
    }
    if (oldGift || oldCode) {
      const gift = picked(cart) ? giftFromCart(cart) : oldGift ? {title:oldGift.product_title,variant:oldGift.variant_title,sku:oldGift.sku,id:oldGift.variant_id,handle:oldGift.handle} : null;
      const updated = await update(cart,gift);publish(updated);return updated;
    }
    return cart;
  };
  const showLauncher = cart => { if (launcher) launcher.hidden = picked(cart) || !dialog?.dataset.product; };
  document.addEventListener('cart:change', async event => {
    if (busy || !event.detail?.cart) return;
    busy = true;
    try {showLauncher(await reconcile(await api('cart.js')));} catch (error) {console.error('Gift selection check failed',error);} finally {busy=false;}
  });
  document.addEventListener('submit',event=>{
    if (busy && event.submitter?.name === 'checkout') {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  const initial = (async()=>{
    busy=true;
    try {const cart=await reconcile(await api('cart.js'));showLauncher(cart);return cart;} finally {busy=false;}
  })();
  initial.catch(()=>{});
  if (!dialog || !launcher) return;
  const form = () => [...document.querySelectorAll('form[is="product-form"]')].find(f=>f.querySelector('[name="product-id"]')?.value===dialog.dataset.product && !f.closest('quick-buy-drawer'));
  const open = async (edit=false) => {
    if (busy) return;
    try {
      const cart=await api('cart.js');
      if (edit && !eligible(cart)) return;
      if (!edit && picked(cart)) return;
      if (!dialog.querySelector('input[name="avena-pack-gift-choice"]')) return;
      changeOnly=edit;
      claimButton.textContent=edit ? dialog.dataset.save : originalLabel;
      errorLabel.textContent='';
      if(edit && picked(cart)) {
        const option=[...dialog.querySelectorAll('option')].find(option=>option.value===cart.attributes['Gave-variant-ID']);
        if(option){option.parentElement.value=option.value;option.closest('label').querySelector('input').checked=true;}
      }
      claimButton.disabled=!dialog.querySelector('input[name="avena-pack-gift-choice"]:checked');
      dialog.querySelector('.avena-pack-gift-purchase').hidden=edit;
      dialog.showModal();
      try {sessionStorage.setItem('avena-pack-gift-seen','1');}catch(error){}
    } catch(error) {}
  };
  document.addEventListener('click',async event=>{
    if(event.target.closest('[data-pack-gift-change]')) {await open(true);return;}
    const remove=event.target.closest('[data-pack-gift-remove]');
    if(!remove || busy)return;
    busy=true;remove.disabled=true;
    try {
      const cart=await update(await api('cart.js'),null);publish(cart);showLauncher(cart);
      if (/\/cart\/?$/.test(location.pathname)) location.reload();
    } catch(error) {remove.closest('.avena-pack-summary').querySelector('[role="status"]').textContent=dialog.dataset.error;}
    finally {busy=false;remove.disabled=false;}
  });
  const close = () => {if(!busy)dialog.close();};
  launcher.addEventListener('click',()=>open(false));
  dialog.querySelector('.avena-pack-gift-close').addEventListener('click',close);
  dialog.querySelector('.avena-pack-gift-dismiss').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  dialog.addEventListener('change',event=>{
    if(event.target.matches('select'))event.target.closest('label').querySelector('input').checked=true;
    claimButton.disabled=!dialog.querySelector('input[name="avena-pack-gift-choice"]:checked');
  });
  initial.then(cart=>{
    if(picked(cart) || !dialog.dataset.product)return;
    let seen=false;try{seen=sessionStorage.getItem('avena-pack-gift-seen')==='1';}catch(error){}
    if(!seen)setTimeout(()=>{if(!document.querySelector('cart-drawer[open],quick-buy-drawer[open],dialog[open]'))open(false);},3000);
  }).catch(()=>{});
  claimButton.addEventListener('click',async()=>{
    if(busy)return;
    const choice=dialog.querySelector('input[name="avena-pack-gift-choice"]:checked');
    if(!choice)return;
    const productForm=form();
    let data;
    if(!changeOnly){
      if(!productForm || !productForm.checkValidity()){errorLabel.textContent=dialog.dataset.select;return;}
      data=new FormData(productForm);
      if(!data.get('id') || data.get('selling_plan') || productForm.querySelector('button[type="submit"]')?.disabled){errorLabel.textContent=dialog.dataset.select;return;}
    }
    busy=true;claimButton.disabled=true;claimButton.textContent=dialog.dataset.busy;errorLabel.textContent='';
    try {
      const option=choice.closest('label').querySelector('select').selectedOptions[0];
      const product=await api('products/'+encodeURIComponent(choice.dataset.handle)+'.js');
      const variant=product.variants.find(v=>String(v.id)===option.value && v.available);
      if(!variant)throw new Error('Gift unavailable');
      if(!changeOnly){
        const properties={};
        for(const [name,value] of data){const match=name.match(/^properties\[(.+)\]$/);if(match && typeof value==='string')properties[match[1]]=value;}
        await api('cart/add.js',{items:[{id:Number(data.get('id')),quantity:Math.max(1,Number(data.get('quantity'))||1),properties}]});
        changeOnly=true;
      }
      const before=await api('cart.js');
      if(!eligible(before))throw new Error('No qualifying item');
      const cart=await update(before,{title:product.title,handle:product.handle,id:variant.id,variant:variant.title,sku:variant.sku});
      dialog.close();showLauncher(cart);publish(cart,true);
      if(/\/cart\/?$/.test(location.pathname))location.reload();
    } catch(error){
      errorLabel.textContent=dialog.dataset.error;
      try {publish(await api('cart/update.js',{sections:sections(),sections_url:location.pathname}));}catch(refreshError){}
    } finally {busy=false;claimButton.disabled=false;claimButton.textContent=changeOnly ? dialog.dataset.save : originalLabel;}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elsniva-cart-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elsniva-cart-editor')) {
  class ElsnivaCartEditor extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.selects=[...this.querySelectorAll('select')];
      this.button=this.querySelector('button');
      this.message=this.querySelector('[role="status"]');
      this.selects.forEach((select,index)=>select.addEventListener('change',()=>this.sync(index)));
      this.button.addEventListener('click',()=>this.save());
      this.sync(-1);
    }
    sync(changed) {
      this.selects.forEach((select,index)=>{
        const prefix=this.selects.slice(0,index).map(s=>s.value);
        for(const option of select.options) option.disabled=!this.variants.some(v=>v.available && v.options[index]===option.value && prefix.every((value,i)=>v.options[i]===value));
        if(index>changed && changed>=0 && select.selectedOptions[0]?.disabled) {
          const next=[...select.options].find(o=>!o.disabled);
          if(next)select.value=next.value;
        }
      });
      const choices=this.selects.map(select=>select.value);
      this.target=this.variants.find(v=>v.available && choices.every((value,index)=>v.options[index]===value));
      this.button.disabled=!this.target || String(this.target.id)===this.dataset.current;
      this.message.textContent=this.target?'':this.dataset.unavailable;
    }
    async save() {
      const drawer=this.closest('cart-drawer');
      if(!this.target || drawer.hasAttribute('data-avena-editing'))return;
      const root=window.Shopify.routes.root;
      const api=async(path,body)=>{
        const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}:{cache:'no-store'});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||'Cart update failed');
        return result;
      };
      const sectionIds=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sectionIds}}));
      const bundle={sections:[...new Set(sectionIds)].slice(0,5),sections_url:location.pathname};
      const publish=cart=>{
        if(cart.sections && Object.values(cart.sections).every(Boolean))document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      };
      const token=crypto.randomUUID();
      const label=this.button.textContent;
      drawer.setAttribute('data-avena-editing','');drawer.setAttribute('aria-busy','true');
      const locked=[...drawer.querySelectorAll('button,input,select')].filter(e=>!e.disabled);
      locked.forEach(e=>e.disabled=true);
      this.button.textContent=this.dataset.busy;this.message.textContent='';
      let original,removed=false;
      const matches=item=>item.variant_id===original.variant_id && JSON.stringify(item.properties||{})===JSON.stringify(original.properties||{}) && item.selling_plan_allocation?.selling_plan.id===original.selling_plan_allocation?.selling_plan.id;
      try {
        const before=await api('cart.js');
        original=before.items.find(item=>item.key===this.dataset.key);
        if(!original)throw new Error('Cart item changed');
        const replacement={id:this.target.id,quantity:original.quantity,properties:{...original.properties,_avena_edit:token}};
        if(original.selling_plan_allocation)replacement.selling_plan=original.selling_plan_allocation.selling_plan.id;
        await api('cart/add.js',{items:[replacement]});
        const interim=await api('cart.js');
        const old=interim.items.find(matches);
        if(!old)throw new Error('Cart item changed');
        const cart=await api('cart/change.js',{id:old.key,quantity:0,...bundle});
        removed=true;
        const edited=cart.items.find(item=>item.properties?._avena_edit===token);
        if(!edited || edited.quantity!==original.quantity || (original.properties?._avena_gift && edited.final_line_price!==0))throw new Error('Variant cannot retain gift offer');
        publish(cart);
      } catch(error) {
        try {
          if(removed && original) {
            const restore={id:original.variant_id,quantity:original.quantity,properties:original.properties};
            if(original.selling_plan_allocation)restore.selling_plan=original.selling_plan_allocation.selling_plan.id;
            await api('cart/add.js',{items:[restore]});
          }
          const current=await api('cart.js');
          const added=current.items.find(item=>item.properties?._avena_edit===token);
          if(added)publish(await api('cart/change.js',{id:added.key,quantity:0,...bundle}));
          this.message.textContent=this.dataset.error;
        } catch(restoreError) { location.href=root+'cart'; }
      } finally {
        drawer.removeAttribute('data-avena-editing');drawer.removeAttribute('aria-busy');
        locked.forEach(e=>e.disabled=false);this.button.textContent=label;
      }
    }
  }
  customElements.define('elsniva-cart-editor',ElsnivaCartEditor);
}
  } catch(e) { console.error(e); }
})();

})();
